import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogleIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M29.577 16.3013C29.577 15.1851 29.4846 14.3706 29.2846 13.5259H16.2783V18.5639H23.9127C23.7589 19.816 22.9276 21.7015 21.0806 22.9685L21.0547 23.1372L25.167 26.2593L25.4519 26.2871C28.0686 23.9189 29.577 20.4344 29.577 16.3013Z",
			fill: "#4285F4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.2765 29.5754C20.0167 29.5754 23.1566 28.3686 25.4501 26.287L21.0788 22.9684C19.909 23.7679 18.339 24.326 16.2765 24.326C12.6133 24.326 9.50412 21.9578 8.3958 18.6846L8.23333 18.698L3.95729 21.9412L3.90137 22.0935C6.17935 26.5283 10.8585 29.5754 16.2765 29.5754Z",
			fill: "#34A853"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.39831 18.6849C8.10586 17.8402 7.93662 16.9351 7.93662 15.9999C7.93662 15.0647 8.10586 14.1597 8.38292 13.3149L8.37518 13.135L4.04553 9.83984L3.90386 9.90588C2.96499 11.7462 2.42627 13.8127 2.42627 15.9999C2.42627 18.1871 2.96499 20.2536 3.90386 22.0939L8.39831 18.6849Z",
			fill: "#FBBC05"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.2766 7.67358C18.8778 7.67358 20.6325 8.77472 21.633 9.69491L25.5425 5.95401C23.1415 3.76681 20.0168 2.42432 16.2766 2.42432C10.8585 2.42432 6.17936 5.4713 3.90137 9.90601L8.38043 13.3151C9.50415 10.0418 12.6133 7.67358 16.2766 7.67358Z",
			fill: "#EB4335"
		})
	]
});
export default SvgGoogleIcon;
